<template>
  <div class="ge-root">
    <div class="ge-toolbar">
      <div class="ge-toolbar-info">✏️ Modo edición · Solo ADMIN y DTYCAL</div>
      <div class="ge-toolbar-actions">
        <button class="ge-btn ge-btn-add" @click="addPunto">➕ Añadir punto</button>
        <button class="ge-btn ge-btn-save" @click="guardar" :disabled="guardando">
          {{ guardando ? '⏳ Guardando...' : '💾 Guardar todo' }}
        </button>
      </div>
    </div>
    <div class="ge-body">
      <div class="ge-sidebar">
        <div class="ge-sidebar-title">📑 Puntos ({{ puntos.length }})</div>
        <div v-for="(p, idx) in puntos" :key="idx" :class="['ge-punto-item', { 'ge-punto-active': selectedIdx === idx }]" @click="selectPunto(idx)">
          <span class="ge-punto-num">{{ idx + 1 }}</span>
          <span class="ge-punto-titulo">{{ p.titulo }}</span>
        </div>
      </div>
      <div class="ge-main">
        <div v-if="selectedIdx >= 0 && puntos[selectedIdx]" class="ge-editor-panel">
          <div class="ge-field">
            <label class="ge-label">Título del punto</label>
            <input v-model="puntos[selectedIdx].titulo" class="ge-input" />
          </div>
          <div class="ge-field">
            <label class="ge-label">Descripción breve</label>
            <input v-model="puntos[selectedIdx].meta" class="ge-input ge-input-sm" />
          </div>
          <div class="ge-field">
            <label class="ge-label">Contenido</label>
            <div class="ge-format-bar">
              <button @click="fmt('bold')" title="Negrita"><b>B</b></button>
              <button @click="fmt('italic')" title="Cursiva"><i>I</i></button>
              <button @click="fmt('underline')" title="Subrayado"><u>U</u></button>
              <span class="ge-sep"></span>
              <button @click="fmtBlock('h3')" title="Título sección">H3</button>
              <button @click="fmtBlock('h4')" title="Subtítulo">H4</button>
              <button @click="fmtBlock('p')" title="Párrafo normal">¶</button>
              <span class="ge-sep"></span>
              <button @click="fmt('insertUnorderedList')" title="Lista viñetas">• Lista</button>
              <button @click="fmt('insertOrderedList')" title="Lista numerada">1. Num</button>
              <span class="ge-sep"></span>
              <button @click="fmt('undo')" title="Deshacer">↩</button>
              <button @click="fmt('redo')" title="Rehacer">↪</button>
            </div>
            <div ref="editorArea" class="ge-contenteditable" contenteditable="true" @blur="saveCurrentContent" @input="onInput"></div>
          </div>
          <div class="ge-punto-actions">
            <button v-if="selectedIdx > 0" class="ge-btn ge-btn-move" @click="moverPunto(-1)">⬆ Subir</button>
            <button v-if="selectedIdx < puntos.length - 1" class="ge-btn ge-btn-move" @click="moverPunto(1)">⬇ Bajar</button>
            <button class="ge-btn ge-btn-del" @click="eliminarPunto">🗑 Eliminar</button>
          </div>
        </div>
        <div v-else class="ge-no-selection"><p>👈 Selecciona un punto para editarlo</p></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GuiaEditor',
  props: {
    contenidoHtml: { type: String, default: '' },
    onSave: { type: Function, default: null }
  },
  data: function() {
    return { puntos: [], selectedIdx: -1, guardando: false };
  },
  mounted: function() {
    this.parsearHtml(this.contenidoHtml);
    if (this.puntos.length > 0) this.selectPunto(0);
  },
  methods: {
    parsearHtml: function(html) {
      var div = document.createElement('div');
      div.innerHTML = html;
      var secs = div.querySelectorAll('section[data-punto]');
      var pts = [];
      for (var i = 0; i < secs.length; i++) {
        var s = secs[i];
        var h2 = s.querySelector('h2');
        var meta = s.querySelector('.punto-meta');
        var hdr = s.querySelector('.punto-header');
        var con = '';
        for (var j = 0; j < s.children.length; j++) {
          if (s.children[j] !== hdr) con += s.children[j].outerHTML + '\n';
        }
        pts.push({
          titulo: h2 ? h2.textContent.trim() : 'Punto ' + (i+1),
          meta: meta ? meta.textContent.trim() : '',
          contenido: con.trim()
        });
      }
      if (pts.length === 0) pts.push({ titulo: 'Nuevo punto', meta: '', contenido: '<p>Escribe aquí...</p>' });
      this.puntos = pts;
    },
    selectPunto: function(idx) {
      this.saveCurrentContent();
      this.selectedIdx = idx;
      this.$nextTick(function() {
        if (this.$refs.editorArea) {
          this.$refs.editorArea.innerHTML = this.puntos[idx].contenido || '<p></p>';
        }
      }.bind(this));
    },
    saveCurrentContent: function() {
      if (this.selectedIdx >= 0 && this.$refs.editorArea && this.puntos[this.selectedIdx]) {
        this.puntos[this.selectedIdx].contenido = this.$refs.editorArea.innerHTML;
      }
    },
    onInput: function() { /* contenteditable auto-updates DOM */ },
    fmt: function(cmd) {
      document.execCommand(cmd, false, null);
      if (this.$refs.editorArea) this.$refs.editorArea.focus();
    },
    fmtBlock: function(tag) {
      document.execCommand('formatBlock', false, '<' + tag + '>');
      if (this.$refs.editorArea) this.$refs.editorArea.focus();
    },
    addPunto: function() {
      this.saveCurrentContent();
      this.puntos.push({ titulo: 'Nuevo punto', meta: 'Descripción', contenido: '<p>Escribe aquí el contenido.</p>\n<h4>📋 Qué pedir al cliente</h4>\n<ul><li>Dato 1</li></ul>\n<h4>💡 Consejos</h4>\n<ul><li>Consejo 1</li></ul>' });
      this.selectPunto(this.puntos.length - 1);
    },
    eliminarPunto: function() {
      if (this.puntos.length <= 1) return;
      if (confirm('¿Eliminar "' + this.puntos[this.selectedIdx].titulo + '"?')) {
        this.puntos.splice(this.selectedIdx, 1);
        this.selectPunto(Math.min(this.selectedIdx, this.puntos.length - 1));
      }
    },
    moverPunto: function(dir) {
      this.saveCurrentContent();
      var i = this.selectedIdx, n = i + dir;
      if (n < 0 || n >= this.puntos.length) return;
      var tmp = this.puntos[i];
      this.$set(this.puntos, i, this.puntos[n]);
      this.$set(this.puntos, n, tmp);
      this.selectPunto(n);
    },
    reconstruirHtml: function() {
      this.saveCurrentContent();
      var div = document.createElement('div');
      div.innerHTML = this.contenidoHtml;
      var style = div.querySelector('style');
      var header = div.querySelector('.guia-header');
      var h = '';
      if (style) h += style.outerHTML + '\n\n';
      h += '<div class="guia-simecal">\n\n';
      if (header) h += header.outerHTML + '\n\n';
      h += '<nav class="guia-nav">\n';
      for (var i = 0; i < this.puntos.length; i++) {
        var c = i === 0 ? ' class="nav-common"' : '';
        var lb = this.puntos[i].titulo.replace(/<[^>]+>/g,'').substring(0,30);
        h += '<a onclick="event.preventDefault();var el=document.querySelector(\'[data-punto=&quot;'+(i+1)+'&quot;]\');if(el)el.scrollIntoView({behavior:\'smooth\',block:\'start\'});return false;" style="cursor:pointer"'+c+'>'+(i+1)+'. '+lb+'</a>\n';
      }
      h += '</nav>\n\n';
      for (var j = 0; j < this.puntos.length; j++) {
        var p = this.puntos[j], num = j+1;
        h += '<section data-punto="'+num+'" id="punto-'+num+'" class="guia-punto">\n';
        h += '<div class="punto-header"><div class="punto-num">'+num+'</div><div><h2>'+(p.titulo||'Sin título')+'</h2><div class="punto-meta">'+(p.meta||'')+'</div></div></div>\n\n';
        h += p.contenido + '\n</section>\n\n';
      }
      h += '</div>';
      return h;
    },
    guardar: function() {
      this.guardando = true;
      var html = this.reconstruirHtml();
      if (this.onSave) { this.onSave(html, function() { this.guardando = false; }.bind(this)); }
      else { this.guardando = false; }
    }
  }
};
</script>
<style>
.ge-root{background:#0a1128;color:#e8ecf7;min-height:100%;display:flex;flex-direction:column}
.ge-toolbar{background:#1a2e5c;padding:12px 16px;display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:10px}
.ge-toolbar-info{color:#ffd699;font-size:13px;font-weight:500}
.ge-toolbar-actions{display:flex;gap:8px}
.ge-btn{padding:8px 14px;border:none;border-radius:6px;font-size:13px;font-weight:600;cursor:pointer;transition:all .2s}
.ge-btn:hover{transform:translateY(-1px)}
.ge-btn:disabled{opacity:.5;cursor:not-allowed}
.ge-btn-add{background:#00d4ff;color:#0a1128}
.ge-btn-save{background:#00b894;color:#fff}
.ge-btn-move{background:#1a2e5c;color:#e8ecf7;border:1px solid #00d4ff}
.ge-btn-del{background:#ff4d6d;color:#fff}
.ge-body{display:flex;flex:1;min-height:70vh}
.ge-sidebar{width:220px;min-width:220px;background:#0f1b3d;border-right:1px solid #1a2e5c;overflow-y:auto}
.ge-sidebar-title{padding:12px 14px;font-size:14px;font-weight:700;color:#00d4ff;border-bottom:1px solid #1a2e5c}
.ge-punto-item{display:flex;align-items:center;gap:8px;padding:10px 14px;cursor:pointer;border-bottom:1px solid #0a1128;font-size:13px;transition:all .15s}
.ge-punto-item:hover{background:#1a2e5c}
.ge-punto-active{background:#1a2e5c!important;border-left:3px solid #00d4ff}
.ge-punto-num{background:#00d4ff;color:#0a1128;width:24px;height:24px;border-radius:6px;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:11px;flex-shrink:0}
.ge-punto-titulo{color:#c8d1e8;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.ge-punto-active .ge-punto-titulo{color:#fff;font-weight:600}
.ge-main{flex:1;padding:20px;overflow-y:auto}
.ge-editor-panel{max-width:900px}
.ge-field{margin-bottom:16px}
.ge-label{display:block;color:#00d4ff;font-size:12px;font-weight:600;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px}
.ge-input{width:100%;background:#0f1b3d;border:1px solid #1a2e5c;color:#fff;padding:10px 14px;border-radius:6px;font-size:15px;font-weight:600;outline:none}
.ge-input:focus{border-color:#00d4ff}
.ge-input-sm{font-size:13px;font-weight:400;color:#8b9ac8}
.ge-format-bar{display:flex;gap:4px;flex-wrap:wrap;padding:8px;background:#0f1b3d;border-radius:6px 6px 0 0;border:1px solid #1a2e5c;border-bottom:none}
.ge-format-bar button{background:#1a2e5c;color:#e8ecf7;border:none;padding:6px 10px;border-radius:4px;cursor:pointer;font-size:13px;font-weight:600;transition:all .15s}
.ge-format-bar button:hover{background:#00d4ff;color:#0a1128}
.ge-sep{width:1px;background:#1a2e5c;margin:0 4px}
.ge-contenteditable{background:#0f1b3d;border:1px solid #1a2e5c;border-radius:0 0 6px 6px;min-height:400px;padding:16px;color:#e8ecf7;font-size:14px;line-height:1.7;outline:none;overflow-y:auto}
.ge-contenteditable:focus{border-color:#00d4ff;background:#0a1128}
.ge-contenteditable h3{color:#00d4ff;font-size:16px;margin:20px 0 10px;font-weight:600;text-transform:uppercase}
.ge-contenteditable h4{color:#ffd699;font-size:15px;margin:16px 0 8px;font-weight:600}
.ge-contenteditable p{margin:0 0 10px}
.ge-contenteditable ul,.ge-contenteditable ol{padding-left:22px;margin:0 0 10px}
.ge-contenteditable li{margin-bottom:4px}
.ge-contenteditable strong,.ge-contenteditable b{color:#fff}
.ge-contenteditable hr{border:none;border-top:1px solid #1a2e5c;margin:16px 0}
.ge-punto-actions{display:flex;gap:8px;margin-top:16px;padding-top:16px;border-top:1px solid #1a2e5c}
.ge-no-selection{display:flex;align-items:center;justify-content:center;height:100%;color:#8b9ac8;font-size:16px}
</style>
